import React, { useContext } from 'react';
import checkIcon from '../../../../assets/images/icons/checkmark.svg';
import PlayerInsightButton from '../../../PlayerInsightButton/PlayerInsightButton';
import { LocalizationContext } from '../../../../context/localizationContext';
import Styles from './EmailConfirmation.module.scss';

const EmailConfirmation = (props) => {
  const localization = useContext(LocalizationContext);
  const { tileText } = localization;
  const { setLoading, userEmail } = props;

  const replaceEmailPlaceholder = () => {
    return userEmail ? tileText?.emailText.emailSentMessage.replace('{email_placeholder}', userEmail)
      : tileText.emailText.emailSentMessage;
  };

  return (
    <div className={Styles.emailConfirmation}>
      <div className={Styles.emailSentCheck}><img src={checkIcon} alt='checkmark' />{tileText.emailText.emailSent}</div>
      <div className={Styles.instructionsText}>{replaceEmailPlaceholder()}</div>
      <div>{tileText.emailText.redirectInstructions}</div>
      {/* might use this later if we ever add a button to connect to account instead of a refresh */}
      {/* <PlayerInsightButton
        label={tileText.emailText.connectToArccosBtnText}
        onClick={() => setLoading(true)}
      /> */}
    </div>
  );
};

export default EmailConfirmation;
